<template>
	<div class="limited-input">
		<input type="text" :placeholder="placeholder" :maxlength="maxChars" :value="modelValue" :disabled="disabled" @input="$emit('update:modelValue', $event.target.value)" v-if="!textArea" v-cloak />
		<textarea :placeholder="placeholder" :maxlength="maxChars" :value="modelValue" :disabled="disabled" @input="$emit('update:modelValue', $event.target.value)" v-if="textArea" v-cloak />
		<div class="char-limit"><span :class="clsCharLimit()">{{nrChars}} / {{maxChars}}</span></div>
	</div>
</template>




<script>
	export default {
		emits: ['update:modelValue'],
		data: () => ({
		}),
		props: {
			modelValue:  { type: String,  required: false, default: '' },
			placeholder: { type: String,  required: false, default: '' },
			maxCharsRed: { type: Number,  required: false, default: 90 },
			maxChars:    { type: Number,  required: false, default: 100 },
			textArea:    { type: Boolean, required: false, default: false },
			disabled:    { type: Boolean, required: false, default: false }
		},
		methods: {
			clsCharLimit() {
				return {
					'red' : (this.nrChars > this.maxCharsRed)
				};
			}
		},
		computed: {
			nrChars() {
				return (this.modelValue.length);
			}
		}
	};
</script>




<style scoped>
	[v-cloak] {
		display:none;
	}

	.char-limit {
		display:flex;
		justify-content:right;
		margin-top:2px;
	}

	.char-limit span {
		font-size:0.8em;
		color:gray;
	}

	.char-limit span.red {
		color:red;
	}

	textarea {
		display:block; /* remove excessive whitespace below */
	}
</style>